import { defineStore } from 'pinia'
import type {
  PrideEntry,
  Review,
  SchoolDetails,
  StoreReview,
  StoreTrainingSignupRequest,
} from '~/api'

export const useSchoolStore = defineStore('schoolStore', () => {
  const api = useApi()

  const pageData = ref<SchoolDetails | null>(null)
  const prideEntries = ref<PrideEntry[]>([])

  const directions = computed(() => pageData.value?.directions || [])
  const trainers = computed(() => pageData.value?.trainers || [])
  const lessonTypes = computed(() => pageData.value?.lesson_types || [])
  const gallery = computed(() => pageData.value?.gallery || [])

  const reviews = ref<Review[]>([])

  const fetchSchool = async (id: string) => {
    pageData.value = (await api.public['schools.detail'](id)).data
  }

  const fetchReviews = async (id: string) => {
    reviews.value = (await api.public.schoolReviews(id)).data
  }

  const fetchPrideEntries = async (id: string) => {
    prideEntries.value = (await api.public.schoolPrideEntries(id)).data
  }

  const storeReview = async (id: string, data: StoreReview) => {
    await api.public.storeSchoolReview(id, data)
  }

  const trainingSignup = async (
    id: string,
    data: StoreTrainingSignupRequest,
  ) => {
    await api.public.trainingSignupRequestsStoreSchool(id, data)
  }

  return {
    pageData,
    directions,
    trainers,
    lessonTypes,
    gallery,
    prideEntries,
    reviews,

    fetchSchool,
    fetchReviews,
    fetchPrideEntries,
    storeReview,
    trainingSignup,
  }
})
